export const OFFER_EVENT = {
  // Received when a slider have to appear
  SLIDER_SHOW: 'slider-show',
  // Received after deleting a favorite
  FAVORITE_REMOVE_LOADER: 'favorite-remove-loader',
  // Received after validating a proposal refusal
  PROPOSAL_REMOVE_LOADER: 'proposal-remove-loader',
  // Received after send refused match proposal form
  FAVORITE_OFFER_REMOVE: 'favorite-offer-remove',
  PROPOSAL_OFFER_REMOVE: 'proposal-offer-remove',
  // Highlight proposal when hover on the list
  PROPOSAL_OFFER_LIST_HOVER: 'proposal-offer-list-hover',
  // Scroll to a proposal when clicked on the map
  PROPOSAL_OFFER_SCROLL_TO: 'proposal-offer-scroll-to',
  // Received after send refused reasons to back-end
  PROPOSAL_REFUSE: 'proposal-refuse',
};

export const SLIDERS = {
  // Call when match add a proposal on user's profile
  OFFER_PROPOSAL: 'offer-proposal',
  // Call when user refuse a match proposal
  REFUSE_PROPOSAL: 'refuse-proposal',
};
